// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { chain as loadProductChain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomGetProductByPathApiV2Parameter, getProductByPath } from "@pacific/App/Services/CustomProductService";

interface Props {
    apiParameter: CustomGetProductByPathApiV2Parameter;
    apiResult: ProductModel;
}

type Parameter = {
    path: string;
    styledOption?: string;
    getProductLines?: boolean;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel>;

type HandlerType = Handler<Parameter, Props>;

export const setHandler: HandlerType = (props) => {
    // without this the parameter type will be taken from LoadProductByPath.
};

export const XngRequestDataFromApi: HandlerType = async props => {
    props.apiParameter = {
        ...props.apiParameter,
        cache: "no-store",
    };

    props.apiParameter.expand = [
        ...(props.apiParameter.expand || []),
        "previouslypurchased",
      ] as any;

    props.apiResult = await getProductByPath(props.apiParameter);
};

const chain = [
    setHandler,
    ...loadProductChain,
];

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);

export { chain };

const refreshProduct = createHandlerChainRunner(chain, "RefreshProduct");
export default refreshProduct;
